import type { RootState } from 'store'
import type { ActionTree } from 'vuex'
import type { SettingState } from './types'
import { SettingService } from '../service'
import { GET_ALL_SETTINGS, CREATE_OR_UPDATE_SETTING } from './types'

const settingService = new SettingService()

export const actions: ActionTree<SettingState, RootState> = {
  actGetAllSettings({ commit }) {
    return settingService.getAllSettings().then((settings) => {
      commit(GET_ALL_SETTINGS, settings)
    })
  },
  actCreateOrUpdateSetting({ commit }, params: object) {
    return settingService.createOrUpdateSetting(params).then((settings) => {
      commit(CREATE_OR_UPDATE_SETTING, settings)
    })
  },
}
